/* Extracted from snippets/product-quick-specs.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
      const dataEl = document.getElementById('VariantSpecsData');
      if (!dataEl) return;
      let specMap;
      try {
        specMap = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      const applySpecs = (variantId) => {
        const specs = specMap[variantId];
        if (!specs) return;
        for (const node of document.querySelectorAll('[data-spec-slot]')) {
          const slot = node.dataset.specSlot;
          if (Object.prototype.hasOwnProperty.call(specs, slot)) {
            node.textContent = specs[slot];
          }
        }
      };

      document.addEventListener('variant:change', (event) => {
        const detail = event.detail || {};
        const id = detail.variantId || (detail.variant && detail.variant.id);
        if (id) applySpecs(id);
      });
    })();
